var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#292929"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7225 13.3668C10.7225 12.8108 10.7996 12.3526 10.9538 11.9923C11.1079 11.6319 11.2909 11.3539 11.5029 11.1583C11.7148 10.9524 11.9942 10.7362 12.341 10.5097C12.7264 10.2625 13.0058 10.036 13.1792 9.83012C13.3622 9.6139 13.4538 9.31017 13.4538 8.91892C13.4538 8.4556 13.2996 8.10039 12.9913 7.85328C12.6734 7.60618 12.1676 7.48263 11.474 7.48263H10V6H11.6474C12.1676 6 12.606 6.05148 12.9624 6.15444C13.3285 6.2471 13.6513 6.3964 13.9306 6.60232C14.2678 6.85972 14.5279 7.17889 14.711 7.55985C14.9037 7.9408 15 8.37838 15 8.87259C15 9.30502 14.9326 9.67053 14.7977 9.96911C14.6724 10.2574 14.5183 10.4891 14.3353 10.6641C14.1522 10.8391 13.9017 11.0399 13.5838 11.2664C13.2852 11.4723 13.0491 11.6577 12.8757 11.8224C12.7119 11.9768 12.5723 12.1828 12.4566 12.4402C12.341 12.6873 12.2832 12.9961 12.2832 13.3668V14.6178H10.7225V13.3668ZM11.5029 18C11.1946 18 10.9345 17.8867 10.7225 17.6602C10.5106 17.4337 10.4046 17.1609 10.4046 16.8417C10.4046 16.5431 10.5106 16.2857 10.7225 16.0695C10.9345 15.8533 11.1946 15.7452 11.5029 15.7452C11.8015 15.7452 12.052 15.8533 12.2543 16.0695C12.4663 16.2857 12.5723 16.5431 12.5723 16.8417C12.5723 17.1609 12.4663 17.4337 12.2543 17.6602C12.052 17.8867 11.8015 18 11.5029 18Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.9a4c3d5e644a680ef38e79078697fd7b.svg";
export { ForwardRef as ReactComponent };